import { decodeHtmlEntities } from '../utils/decodeHtmlEntities';
import { ThemeOption } from '../types/option';
import { fcMovideskHttpClient } from './httpClient';

type ThemeDto = {
  id: string;
  name: string;
  allowAllCategories: boolean;
  categories: string[];
};
type ThemesResponseDto = { options: ThemeDto[] };

export async function getThemes(signal?: AbortSignal): Promise<ThemeOption[]> {
  const response = await fcMovideskHttpClient.get<ThemesResponseDto>('/theme', { signal });

  return response.options.map((theme) => ({
    id: theme.id,
    label: decodeHtmlEntities(theme.name).trim(),
    allowAllCategories: theme.allowAllCategories,
    categories: theme.categories ?? [],
  }));
}
